import { getContractList } from "api/contract_list";
import { APIListData } from "api/types";
import { AxiosError } from "axios";
import { Contract } from "models";
import { useState } from "react";
import { useQuery } from "react-query";
import { TContractFilter } from "types/TContractFilter";
import { TSearchParamsRequired } from "types/TSearchParams";

const useLoadContracts = ({
  searchParams
}: {
  searchParams: TSearchParamsRequired<TContractFilter>;
}) => {
  const [count, setCount] = useState(0);
  const { isLoading, error, data, refetch } = useQuery<APIListData<Contract>, AxiosError>({
    queryKey: [
      "contract_list",
      searchParams.page,
      searchParams.page_size,
      searchParams.search,
      searchParams.filter,
      searchParams.ordering
    ],
    queryFn: () =>
      getContractList({
        page: searchParams.page,
        size: searchParams.page_size,
        search: searchParams.search,
        filter: searchParams.filter,
        ordering: searchParams.ordering
      }),
    retry: (failureCount, error) => {
      if (error.response?.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
    refetchOnWindowFocus: false,
    onSuccess: ({ data }) => {
      if (data.count !== count) setCount(data.count);
    }
  });

  return {
    count,
    isLoading,
    error,
    refetch,
    contracts: data?.data?.results || ([] as Contract[])
  };
};

export default useLoadContracts;
